import ReactMarquee from "react-fast-marquee";

const items = [
  "Visite specialistiche",
  "Anemie",
  "Piastrinopenie",
  "Linfomi",
  "Leucemie",
  "Mielomi",
  "Follow-up oncoematologico",
  "Second opinion",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="py-14 md:py-20 border-y border-[#E5E1D8] bg-[#EFECE7]"
      aria-label="Aree di competenza"
    >
      <ReactMarquee gradient={false} speed={30} pauseOnHover>
        {items.map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-16 mr-16 font-serif-display text-3xl md:text-5xl text-[#1A1D1A]"
          >
            <span className="italic font-light">{item}</span>
            <span className="w-2 h-2 rounded-full bg-[#8A6D56]" aria-hidden />
          </div>
        ))}
      </ReactMarquee>
    </section>
  );
}
